import { unsafeCSS } from 'lit';

// Base URL for the icons directory on the CDN
const scriptUrl = new URL(import.meta.url);
const scriptDir = scriptUrl.pathname.substring(
	0,
	scriptUrl.pathname.lastIndexOf('/')
);
const ICONS_BASE_URL = new URL(
	`${scriptDir}/icons/`,
	scriptUrl.origin
).href;

let publicIcons = false;

// Initialize iconNames as an exported array
export const iconNames = [];

// Fetch the list of icons from icons.json
async function fetchIconList() {
	try {
		let response = await fetch(`${ICONS_BASE_URL}icons.json`);
		if (!response.ok) {
		    console.warn('Failed to fetch icon list. Checking public folder.');
		    publicIcons = true;
            response = await fetch(`/icons/icons.json`);
            if (!response.ok)
            {
			    throw new Error('Failed to fetch icon list');
            }
		}
		const iconFiles = await response.json();
		return iconFiles;
	} catch (error) {
		console.error('Error fetching icon list:', error);
		return [];
	}
}

// Populate iconNames asynchronously
fetchIconList().then(iconFiles => {
	// Clear and update iconNames in place
	while (iconNames.length > 0) iconNames.pop();
	iconFiles.forEach(file => {
		const name = file.replace(/.svg$/, '');
		iconNames.push(name);
	});
}).catch(() => {
	// Ensure iconNames remains empty on error
	while (iconNames.length > 0) iconNames.pop();
});

// Generate CSS rules for icons
async function generateIconStyles() {
	// Wait for iconNames to be populated by reusing fetchIconList
	const iconFiles = await fetchIconList();
	const tempIconNames = iconFiles.map(file => file.replace(/.svg$/, ''));
	
	const base_url = publicIcons ? 
	    `/icons/`:
        ICONS_BASE_URL;

	// Map icon names to CSS rules
	const iconRules = tempIconNames
		.map(name => `
			.i-${name} {
				mask-image: url("${base_url}${name}.svg");
				-webkit-mask-image: url("${base_url}${name}.svg");
			}`)
		.join('\n');

	// Return the complete CSS
	return unsafeCSS(`
		:host {
			display: inline-block;
			line-height: 1;
			font-size: inherit;
			vertical-align: middle;
		}

		.icon {
			display: block;
			background-size: contain;
			fill: currentColor;
			background-repeat: no-repeat;
			background-position: center;
			background-color: currentColor;
			mask-repeat: no-repeat;
			mask-position: center;
			mask-size: contain;
			-webkit-mask-repeat: no-repeat;
			-webkit-mask-position: center;
			-webkit-mask-size: contain;
		}

		${iconRules}
	`);
}

// Export the promise that resolves to the CSS
export default generateIconStyles();
